const formatTen = (area, first, last) => {
  if (last) {
    return `(${area}) ${first} - ${last}`
  } else if (first) {
    return `(${area}) ${first}`
  }
  return area
}

const divide = (tele) => ({
  area: tele.substring(0, 3),
  first: tele.substring(3, 6),
  last: tele.substring(6),
})

export const unformat = (input) => input && input.replace(/[^0-9]/g, '')

export const format = (input) => {
  if (typeof input === 'undefined') {
    return ''
  }
  let tele = unformat(input)
  if (tele.length > 10) {
    const country = tele.substring(0, tele.length - 10)
    tele = tele.substring(country.length)
    const { area, first, last } = divide(tele)
    return `${country} ${formatTen(area, first, last)}`
  }
  const { area, first, last } = divide(tele)
  return formatTen(area, first, last)
}

export default { format, unformat }
